import BankIdModal from './bank-id-modal';

export { BankIdModal };
